<template>
  <div class="pix-signalr-manager">
    <div v-show="isSignalrOnline" class="pix-signalr-manager-status_online"></div>
    <!-- <div v-show="!isSignalrOnline" class="pix-signalr-manager-status_offline"></div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'pix-signalr-manager',

  components: {},

  directives: {},

  mixins: [],

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      isSignalrOnline: 'signalrModule/getSignalrConnectionStatus',
    }),
  },

  watch: {},

  // Lifecycle hooks (ordered as they are called: beforeCreate, created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, destroyed)

  methods: {},

};
</script>

<style scoped>
.pix-signalr-manager-status_online {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: green;
}

.pix-signalr-manager-status_offline {
width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;
}

</style>
